import { UserRole } from '@xeetr/types/enums'
import { createContext, ReactNode, useContext } from 'react'

const auth0 = {
  isLoading: false,
  isAuthenticated: true,
  user: {
    sub: 'auth0|646dcf51dfa2fdd5517d417c',
    name: 'Local Development User',
    email: 'dev@xeetr.local',
    email_verified: true,
    picture:
      'https://github.com/primait/localauth0/blob/master/web/assets/static/media/localauth0.png',
    // Custom claims - roles for local development (must match AUTH0_TOKEN_NAMESPACE in API)
    'https://www.xeetr.de/roles': [UserRole.DEVELOPER, UserRole.ADMIN],
  },
  loginWithRedirect: async () => {},
  logout: () => {},
  getAccessTokenSilently: async () => 'mock-access-token',
  getIdTokenClaims: async () => ({
    __raw: 'mock-id-token',
    sub: 'auth0|646dcf51dfa2fdd5517d417c',
    name: 'Local Development User',
    email: 'dev@xeetr.local',
    'https://www.xeetr.de/roles': [UserRole.DEVELOPER, UserRole.ADMIN],
  }),
}

const MockAuth0Context = createContext(auth0)

export const MockAuth0Provider = ({ children }: { children: ReactNode }) => {
  return <MockAuth0Context.Provider value={auth0}>{children}</MockAuth0Context.Provider>
}

export const useMockAuth0 = () => useContext(MockAuth0Context)
